import { useEffect } from 'react'
import { useAuthenticator } from '@aws-amplify/ui-react'
import { useBeforeUnload } from 'react-router-dom'
import { Auth } from 'aws-amplify'
import { fromCognitoIdentityPool } from '@aws-sdk/credential-providers'
import awsconfig from 'aws-exports'
import { useCompanyInfo } from './company'


export const useCredential = () => {
    const ua = useAuthenticator(c => [c.user])

    const cognitoId = ua.user.signInUserSession.idToken.payload.iss.replace('https://', '')

    return fromCognitoIdentityPool({
        clientConfig : { region : awsconfig.aws_project_region },
        identityPoolId : awsconfig.aws_cognito_identity_pool_id,
        logins : {
            [cognitoId] : ua.user.signInUserSession.idToken.jwtToken,
        },
    })
}

export const useUserInfo = () => {
    const ua = useAuthenticator(c => [c.user])

    const attr = ua.user.attributes

    return {
        企業ID : attr['custom:clientId'],
        担当者ID : attr['custom:userId'],
        email : attr.email,
    }
}

export const useDocumentVisibility = () => {
    const { data } = useCompanyInfo()

    useEffect(() => {
        if (!data) return

        const handler = async () => {
            sessionStorage.setItem('shouldReload', '')
            const cu = await Auth.currentUserInfo()
            if (document.visibilityState === 'visible') {
                if (cu?.attributes['custom:clientId'] !== data.企業ID) {
                    sessionStorage.setItem('shouldReload', true)
                    window.location.href = '/'
                }
            }
        }

        document.addEventListener('visibilitychange', handler)
        window.addEventListener('focus', handler)

        return () => {
            document.removeEventListener('visibilitychange', handler)
            window.removeEventListener('focus', handler)
        }
    }, [data])
}

export const useMyBeforeUnload = () => {

    useBeforeUnload(e => {
        if (sessionStorage.getItem('shouldReload')) {
            return
        }
        e.preventDefault()
    })
}
